import React from 'react'
import LanguageSwitcher from './LanguageSwitcher'
import { OrbitalMark } from '../shared/OrbitalMark'

export default function SiteHeader() {
    return (
        <header className="site-header">
            <a className="brand" href="#hero" aria-label="PLANETARY home">
                <OrbitalMark width={28} height={28} className="brand-mark" />
                <span className="brand-name">PLANETARY</span>
            </a>
            <LanguageSwitcher />
        </header>
    )
}
